<template>
  <div class="panel-container is-flex">
    <h5 class="title is-5 is-flex has-text-primary">
      <slot name="header"/>
    </h5>
    <div class="panel-content is-flex">
      <slot name="summary-category"/>
      <slot name="summary-number"/>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="sass" scoped>
  .title
    margin-bottom: 0.5rem
  .panel-container
    padding: 1rem
    height: 100%
    flex-direction: column
    justify-content: flex-start
  .panel-content
    flex-direction: column
    align-items: flex-start
</style>
